import { appConfig } from '../../configs/app-config';
import http from './http-common';

export class BaseApi {
  readonly api = http;
  protected readonly _apiVersion = appConfig.apiVersion;
  protected readonly _apiHeader = appConfig.apiHeader;

  get apiVersion() {
    return this._apiVersion;
  }

  getApiVersionHeader(): Record<string, string> {
    if (!this._apiHeader || !this._apiVersion) {
      console.warn('API version or header is not defined in the app config.');
      return {};
    }
    return { [this._apiHeader]: this._apiVersion };
  }
}
